const features = {
  brandRating: 'brandRating',
  useLob: 'useLob',
  unsubscribeProlonged: 'unsubscribeProlonged',
  breastCancer: 'breastCancer',
  onboardingToolTips: 'onboardingToolTips',
  cardFailedPopupWithDiscount: 'Card failed popup with discount',
  giftSetsSubHeaderBanner: 'giftSetsSubHeaderBanner',
  resubscribeReminderPopup: 'resubscribeReminderPopup',
  twoThreePerfumesPopup: 'twoThreePerfumesPopup',
  giftsetDiscountInfo: 'giftsetDiscountInfo',
  giftSetsDiscount: 'giftSetsDiscount',
  giftSetsMenOnlyDiscount: 'giftSetsMenOnlyDiscount',
  isGoogleBot: 'isGoogleBot',
  resubscribeUnpaid: 'RESUBSCRIBE_UNPAID',
  applePay: 'applePay',
  applePayEcommerce: 'applePayEcommerce',
  fbPluginOnProductPage: 'fbPluginOnProductPage', // TODO: remove
  queueUpgradePopup: 'queueUpgradePopup',
  applePayCardUpdate: 'applePayCardUpdate',
  tossIn: 'tossIn',
  facebookEmailRegistration: 'facebookEmailRegistration',
  productCountSelector: 'productCountSelector',
  onboardingOpenEvent: 'onboardingOpenEvent', // TODO remove? - added on 21.01.2020 by sonatskiy
  animationMp4: 'animationMp4',
  delayBanner: 'delayBanner',
  unskipFlow: 'unskipFlow',
  blackFridayForSpecialFlows: 'blackFridayForSpecialFlows',
  blackFridayForFacebook: 'blackFridayForFacebook',
  restoreSubscriptionOrder: 'restoreSubscriptionOrder',
  errorsForMultipleQueries: 'errorsForMultipleQueries',
  openTagFullRatingOnHover: 'openTagFullRatingOnHover',
  newViewSkincareProductPage: 'newViewSkincareProductPage',
  passwordRestoreWithToken: 'passwordRestoreWithToken',
  subscriptionLongProcessingBanner: 'SubscriptionLongProcessingBanner',
  firstTimeVisitModalWithTimer: 'firstTimeVisitModalWithTimer',
  algoliaSearch: 'algoliaSearch',
  queuePageForNonSubscribed: 'queuePageForNonSubscribed',
  flashSale: 'flashSale',
  resubscribeQueuePage: 'resubscribeQueuePage',
  newPayPalSDKIntegration: 'newPayPalSDKIntegration', // TODO remove in the enabled state coz old integration doesn't work anymore - added on 22.01.2020 by sonatskiy
  incubatorNeonHeat: 'incubatorNeonHeat',
  pickOrgflowAndSweatcoin: 'pickOrgflowAndSweatcoin',
  upchargeForPerfumeCase: 'upchargeForPerfumeCase',
  proceedWithPrepaidCard: 'proceedWithPrepaidCard',
  pauseOneMonth: 'pauseOneMonth',
  newSubscriptionPaymentProcess: 'newSubscriptionPaymentProcess',
  billingDay1stDayOfTheMonth: 'billingDay1stDayOfTheMonth',
  mainPageUpcharge: 'mainPageUpcharge',
  improveSurvey: 'improveSurvey',
  longPassword: 'longPassword',
  fullBottle: 'fullBottle',
  fragranceConcepts: 'fragranceConcepts',
  recommendationsImprove: 'recommendationsImprove',
  queuePageBuyYourQueueBlock: 'queuePageBuyYourQueueBlock',
  premiumProductsForNotSubscribed: 'premiumProductsForNotSubscribed',
  appStoreBannerLanding: 'appStoreBannerLanding',
  appStoreBannerSite: 'appStoreBannerSite',
  queueOrderCOGS: 'queueOrderCOGS',
  unpauseOffers: 'unpauseOffers',
  productsBasedOnNotes: 'productsBasedOnNotes',
  collectionsForSale: 'collectionsForSale',
  coFlowTwoItems: 'coFlowTwoItems',
  hidePopularInStates: 'hidePopularInStates',
  hideFragranceFinder: 'hideFragranceFinder',
  hideFragranceHoroscope: 'hideHoroscope',
  hideGifts: 'hideGifts',
  flashSaleBanner: 'flashSaleBanner',
  tasteMakersLanding: 'tasteMakersLanding',
  tossInCartSubtotal: 'tossInCartSubtotal',
  disableInlineCSS: 'disableInlineCSS',
  tossInPopUp: 'tossInPopUp',
  lazyImages: 'lazyImages',
  newBillingPage: 'newBillingPage',
  silverCase: 'whiteCase', // mistake name
  delayCovid19: 'delayCovid-19',
  delayCovidPaymentPage: 'delayCovidPaymentPage',
  brandPage: 'brandPage',
  brandPageTransparentLogo: 'brandPageTransparentLogo',
  pom: 'pom',
  retailValue150Filter: 'retailValue150Filter',
  ecommerceAmazonPayV2: 'ecommerceAmazonPayV2',
  loginWithAppleId: 'loginWithAppleId',
}


export default features
